<template>
    <el-drawer
        title="选择模块"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-table
                ref="libTable"
                :data="tableData"
                stripe
                style="width: 100%;overflow: auto"
                @selection-change="handleChoose"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-c_start">

                        <span style="font-size: 16px;padding: 5px 0">{{scope.row.name}}</span>
                        <img :src="scope.row.coverImg" style="width: 500px; height: 220px" loading="lazy">
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                tableData:[],
                choosedList:[],
                formworkId:this.item,
            }

        },


        methods: {
            close() {
                this.$emit("close");
            },

            loadData() {
                this.$ajaxPost("/websiteModule/list", {
                    form: {formworkId:this.formworkId,enable: true}

                }, data => {
                    this.tableData = data.result;
                })
            },

            sub() {
                let modules = this.choosedList.map(item => {
                    return {
                        type: 1,
                        systemModuleId: item.id,
                        coverImg: item.coverImg,
                        moduleUrl: item.url,
                        uploadNum: item.uploadNum,
                    }
                })
                this.$emit("submit", modules);
                return false;
            },
            handleChoose(val) {
                this.choosedList = val;
            }

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadData() ;
        }


    }
</script>
